import { Box, Grid, Theme, Typography } from '@mui/material';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material/styles';
import { LoadingIndicatorMainGrid } from './LoadingIndicator-Styles';

interface Loader {
  message: string;
}

const LoadingIndicator = (props: Loader) => {
  const theme: Theme = useTheme();
  return (
    <Box
      title="progressBar"
      sx={{
        width: '100%',
      }}
    >
      <LoadingIndicatorMainGrid
        container
        spacing={1}
        justifyContent="flex-start"
        alignItems="center"
        sx={{ m: '0rem' }}
      >
        <Grid item md={2}>
          {
            <Box sx={{ position: 'relative' }}>
              <CircularProgress
                variant="determinate"
                sx={{
                  color: (theme) => theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                }}
                size={40}
                thickness={4}
                {...props}
                value={100}
              />
              <CircularProgress
                variant="indeterminate"
                disableShrink
                sx={{
                  color: theme.custom.colors.secondaryColor,
                  animationDuration: '700ms',
                  position: 'absolute',
                  left: 0,
                  [`& .${circularProgressClasses.circle}`]: {
                    strokeLinecap: 'round',
                  },
                }}
                size={40}
                thickness={4}
                {...props}
              />
            </Box>
          }
        </Grid>
        <Grid item md={10}>
          <Typography
            display="block"
            gutterBottom
            sx={{
              ...theme.custom.styles.primaryDescription,
              paddingTop: '0px',
            }}
          >
            {props.message}
          </Typography>
        </Grid>
      </LoadingIndicatorMainGrid>
    </Box>
  );
};

export default LoadingIndicator;
